import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, Timestamp, deleteDoc, doc } from 'firebase/firestore';

function TeamInput({ members, setMembers }) {
  const [name, setName] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [role, setRole] = useState('developer');

  const addMember = async () => {
    if (name && birthdate && role) {
      await addDoc(collection(db, 'users'), {
        name,
        birthdate: Timestamp.fromDate(new Date(birthdate)),
        role,
      });
      setName('');
      setBirthdate('');
      setRole('developer');
    }
  };

  const deleteMember = async (id) => {
    await deleteDoc(doc(db, 'users', id));
  };

  return (
    <div>
      <div className="flex gap-2 mb-2 flex-wrap bg-[#232946] rounded-xl p-4 shadow border border-orange-300">
        <input
          type="text"
          placeholder="Name"
          className="border border-orange-200 rounded px-2 py-1 flex-1 bg-[#1a1f36] text-orange-50 placeholder-orange-200 focus:border-orange-400"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <input
          type="date"
          className="border border-orange-200 rounded px-2 py-1 bg-[#1a1f36] text-orange-50 placeholder-orange-200 focus:border-orange-400"
          value={birthdate}
          onChange={e => setBirthdate(e.target.value)}
        />
        <select
          className="border border-orange-200 rounded px-2 py-1 bg-[#1a1f36] text-orange-50 focus:border-orange-400"
          value={role}
          onChange={e => setRole(e.target.value)}
        >
          <option value="developer">Developer</option>
          <option value="qa">QA</option>
          <option value="management">Management</option>
          <option value="designer">Designer</option>
        </select>
        <button
          className="bg-orange-500 text-white px-3 py-1 rounded hover:bg-orange-600 shadow"
          onClick={addMember}
          type="button"
        >
          Add
        </button>
      </div>
      {/* Team members list */}
      {members && members.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-4 max-w-full overflow-x-auto">
          {members.map((m) => (
            <span key={m.id} className="px-3 py-1 rounded-full bg-orange-900/80 text-orange-100 text-sm font-semibold border border-orange-400 flex items-center gap-2 whitespace-nowrap">
              {m.name} <span className="text-orange-300">({m.birthdate})</span> <span className="text-orange-400">[{m.role}]</span>
              <button
                className="ml-2 text-orange-300 hover:text-red-400 font-bold focus:outline-none"
                onClick={() => deleteMember(m.id)}
                title="Remove"
                type="button"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default TeamInput; 